<template>
	<div class="news-list-page">
		<!-- banner - 参照法规标准库 -->
		<div class="searchbanner">
			<div class="banner-content">
				<h1 class="banner-title">新闻资讯</h1>
				<p class="banner-subtitle">行业动态 · 政策解读 · 标准更新 · 安全监察</p>
			</div>
		</div>

		<div class="news-wrap">
			<el-row :gutter="20">
				<!-- 左侧：新闻类型筛选 -->
				<el-col :span="6">
					<div class="filter-panel">
						<div class="filter-title">
							<i class="el-icon-s-operation"></i>
							<span>新闻类型</span>
						</div>
						<ul class="filter-list">
							<li v-for="cat in categoryList" :key="cat.value" :class="['filter-item', { active: activeCategory === cat.value }]" @click="handleCategory(cat.value)">
								<span class="filter-name">{{ cat.label }}</span>
								<!-- <span class="filter-count">{{ getCategoryCount(cat.value) }}</span> -->
							</li>
						</ul>
					</div>
				</el-col>

				<!-- 右侧：检索 + 列表 + 分页 -->
				<el-col :span="18">
					<!-- 检索框 -->
					<div class="search-bar">
						<el-input v-model="searchParams.newsTitle" placeholder="输入关键词搜索新闻标题" clearable @keyup.enter.native="handleSearch" @clear="handleSearch">
							<i slot="prefix" class="el-input__icon el-icon-search"></i>
						</el-input>
						<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
					</div>

					<!-- 列表 -->
					<div class="news-list-box" v-if="newsList.length" v-loading="loading" element-loading-text="加载中...">
						<a :href="getNewsDetailUrl(item)" class="news-list-item-link" v-for="item in newsList" :key="item.id" @click.prevent="goDetail(item)">
							<div class="news-item-main">
								<div class="news-item-title-row">
									<span class="news-item-tag">{{ getCategoryLabel(item) }}</span>
									<h3 class="news-item-title" v-html="highlightText(item.newsTitle)"></h3>
								</div>
								<p class="news-item-summary">{{ item.newsDesc }}</p>
								<div class="news-item-meta">
									<span class="meta-item"><i class="el-icon-time"></i> {{ item.updateTime ? item.updateTime.substring(0, 10) : item.createTime ? item.createTime.substring(0, 10) : '' }}</span>
									<span class="meta-item" v-if="item.source"><i class="el-icon-document"></i> {{ item.source }}</span>
									<span class="meta-item" v-if="item.view"><i class="el-icon-view"></i> {{ item.view }} 次阅读</span>
								</div>
							</div>
							<div class="news-item-arrow">
								<i class="el-icon-arrow-right"></i>
							</div>
						</a>
					</div>
					<el-empty v-else description="暂无相关新闻"></el-empty>

					<!-- 分页 -->
					<div class="pagination-wrap" v-if="total > 0">
						<el-pagination
							background
							layout="total, prev, pager, next"
							:total="total"
							:page-size="searchParams.pageSize"
							:current-page.sync="searchParams.pageNum"
							@current-change="handlePageChange"
						></el-pagination>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import { getNewsList } from '@/api/news/news';
	import { getDictData } from '@/api/dict/dict';

	export default {
		name: 'NewsList',
		data() {
			return {
				newsList: [],
				searchKey: '',
				categoryList: [{ value: '', label: '全部资讯' }],

				searchParams: {
					pageNum: 1,
					pageSize: 10,
					newsTitle: '',
					newsType: ''
				},
				total: 0,
				activeCategory: '',
				loading: false
			};
		},
		computed: {},
		created() {
			this.loading = true;
			this.getDictData();
			
		},
		methods: {
			getDictData() {
				getDictData('digit_news_type').then(res => {
					if (res.code === 200) {
						this.categoryList = [{ value: '', label: '全部资讯' }, ...res.data.map(d => ({ value: d.dictValue, label: d.dictLabel }))];
						this.getNewsList();
					} else {
						console.log(res.msg);
					}
				});
			},

			getNewsList() {
				const startTime = Date.now();
				getNewsList(this.searchParams).then(res => {
					if (res.code === 200) {
						this.newsList = res.data.rows || [];
						this.total = res.data.totalNum || 0;
					} else {
						console.log(res.msg);
					}
					// 保证 loading 至少显示 400ms，避免一闪而过
					const elapsed = Date.now() - startTime;
					const delay = Math.max(0, 100 - elapsed);
					setTimeout(() => {
						this.loading = false;
					}, delay);
				});
			},

			// 分类标签
			getCategoryLabel(item) {
				const cat = String(item.newsType ?? '');
				const found = this.categoryList.find(c => c.value === cat);
				return found ? found.label : '资讯';
			},
			// 选择类型 → 走接口过滤
			handleCategory(value) {
				this.loading = true;
				this.searchParams.newsType = value;
				this.activeCategory = value;
				this.searchParams.pageNum = 1;
				this.getNewsList();
			},
			// 搜索 → 走接口过滤
			handleSearch() {
				this.loading = true;
				this.searchKey = this.searchParams.newsTitle;
				this.searchParams.pageNum = 1;
				this.getNewsList();
			},
			// 分页
			handlePageChange(page) {
				this.loading = true;
				this.searchParams.pageNum = page;
				this.getNewsList();
				window.scrollTo({ top: 0, behavior: 'smooth' });
			},
			// 跳转详情
			goDetail(item) {
				this.$router.push({ path: '/NewsDet', query: { id: item.id } });
			},
			// 新闻详情链接
			getNewsDetailUrl(item) {
				return this.$router.resolve({ path: '/NewsDet', query: { id: item.id } }).href;
			},
			// 搜索关键词高亮
			highlightText(text) {
				if (!text) return '';
				const kw = (this.searchKey || '').trim();
				if (!kw) return text;
				const reg = new RegExp(kw.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
				return text.replace(reg, match => `<span class="hl">${match}</span>`);
			}
		}
	};
</script>

<style lang="less" scoped>
	.news-list-page {
		background: #f8fafc;
		min-height: calc(100vh - 120px);
		padding-bottom: 40px;
	}

	// ========== banner ==========
	.searchbanner {
		background: linear-gradient(to right, rgb(0, 166, 61), rgb(0, 153, 102));
		color: #ffffff;
		padding: 32px 0;

		.banner-content {
			width: 78%;
			margin: 0 auto;
		}

		.banner-title {
			font-size: 20px;
			font-weight: 700;
			margin: 0 0 4px;
			line-height: 1.3;
		}

		.banner-subtitle {
			font-size: 14px;
			color: rgba(255, 255, 255, 0.85);
			line-height: 1.5;
			margin: 0;
		}
	}

	.news-wrap {
		width: 80%;
		margin: 24px auto 0;
	}

	// ========== 左侧筛选 ==========
	.filter-panel {
		background: #ffffff;
		border-radius: 12px;
		border: 1px solid #f1f5f9;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		padding: 16px 0;
	}

	.filter-title {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 0 20px 14px;
		font-size: 15px;
		font-weight: 700;
		color: #1e293b;
		border-bottom: 1px solid #f1f5f9;

		i {
			color: #2563eb;
			font-size: 18px;
		}
	}

	.filter-list {
		list-style: none;
		margin: 0;
		padding: 8px 0;
	}

	.filter-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 20px;
		font-size: 14px;
		color: #475569;
		cursor: pointer;
		transition: all 0.2s;
		border-left: 3px solid transparent;

		&:hover {
			background: #f8fafc;
			color: #2563eb;
		}

		&.active {
			background: rgba(37, 99, 235, 0.08);
			color: #2563eb;
			font-weight: 600;
			border-left-color: #2563eb;

			.filter-count {
				background: #2563eb;
				color: #ffffff;
			}
		}
	}

	.filter-count {
		background: #f1f5f9;
		color: #94a3b8;
		font-size: 12px;
		min-width: 24px;
		height: 20px;
		padding: 0 6px;
		border-radius: 10px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		transition: all 0.2s;
	}

	// ========== 右侧检索框 ==========
	.search-bar {
		display: flex;
		gap: 12px;
		background: #ffffff;
		border-radius: 12px;
		padding: 14px 16px;
		border: 1px solid #f1f5f9;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		margin-bottom: 16px;

		/deep/ .el-input__inner {
			height: 40px;
			line-height: 40px;
			border-radius: 8px;
		}

		/deep/ .el-button--primary {
			height: 40px;
			padding: 0 22px;
			font-size: 14px;
			border-radius: 8px;
		}
	}

	// ========== 列表 ==========
	.news-list-box {
		background: #ffffff;
		border-radius: 12px;
		border: 1px solid #f1f5f9;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		overflow: hidden;
	}

	.news-list-item-link {
		display: flex;
		align-items: center;
		gap: 16px;
		padding: 20px 22px;
		cursor: pointer;
		border-bottom: 1px dashed #f1f5f9;
		transition: background 0.2s;
		text-decoration: none;
		color: inherit;

		&:last-child {
			border-bottom: none;
		}

		&:hover {
			background: #f8fafc;

			.news-item-title {
				color: #2563eb;
			}

			.news-item-arrow i {
				transform: translateX(4px);
				color: #2563eb;
			}
		}
	}

	.news-item-main {
		flex: 1;
		min-width: 0;
	}

	.news-item-title-row {
		display: flex;
		align-items: center;
		gap: 10px;
		margin-bottom: 8px;
	}

	.news-item-tag {
		flex-shrink: 0;
		font-size: 12px;
		color: #2563eb;
		background: rgba(37, 99, 235, 0.1);
		padding: 2px 10px;
		border-radius: 4px;
		font-weight: 500;
	}

	.news-item-title {
		flex: 1;
		min-width: 0;
		font-size: 16px;
		font-weight: 700;
		color: #1e293b;
		margin: 0;
		line-height: 1.5;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		transition: color 0.2s;

		/deep/ .hl {
			color: #ef4444;
			font-weight: 700;
		}
	}

	.news-item-summary {
		font-size: 13px;
		color: #64748b;
		line-height: 1.6;
		margin: 0 0 10px;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.news-item-meta {
		display: flex;
		flex-wrap: wrap;
		gap: 18px;
		font-size: 12px;
		color: #94a3b8;

		.meta-item {
			display: inline-flex;
			align-items: center;

			i {
				margin-right: 4px;
				color: #94a3b8;
			}
		}
	}

	.news-item-arrow {
		flex-shrink: 0;
		color: #cbd5e1;

		i {
			font-size: 18px;
			transition: all 0.2s;
		}
	}

	// ========== 分页 ==========
	.pagination-wrap {
		display: flex;
		justify-content: center;
		margin-top: 24px;
	}

	// ========== 响应式 ==========
	@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
		.news-wrap {
			width: 96%;
		}

		.searchbanner .banner-content {
			width: 96%;
		}
	}

	@media screen and (max-width: 767px) {
		.news-wrap {
			width: 100%;
			padding: 0 12px;
		}

		.news-wrap /deep/ .el-row {
			flex-direction: column;
		}

		.news-wrap /deep/ .el-col-6,
		.news-wrap /deep/ .el-col-18 {
			width: 100%;
		}

		.filter-panel {
			margin-bottom: 14px;
		}

		.searchbanner {
			padding: 20px 0;

			.banner-title {
				font-size: 18px;
			}

			.banner-subtitle {
				font-size: 12px;
			}
		}

		.news-item-title {
			font-size: 15px;
		}
	}
</style>
